import React from 'react';
import { DIRECTION_LABELS, REVIEW_STATES, emailTypeLabel } from '../../constants/shipments';
import { formatDateTime, formatPercent } from '../../utils/shipmentsFormat';
import { ReasonChips, TrustBadge } from './StatusBadge';
import { ExternalLinkButton } from './Ui';

// E-mails the shipment was built from (newest first). Everything from the mail is shown as plain text.
const SourceEmails = ({ emails }) => {
  if (!emails || emails.length === 0) return <p className="shp-muted" style={{ margin: 0 }}>K zásilce nejsou přiřazené žádné e-maily.</p>;
  return (
    <div>
      {emails.map((m) => {
        const id = Number(m.id);
        const sender = m.fromName ? `${m.fromName} <${m.from}>` : m.from;
        return (
          <article key={m.id} id={`email-${id}`} className="shp-email" aria-label={`E-mail: ${m.subject || 'bez předmětu'}`}>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
              <TrustBadge trust={m.trust} />
              {m.confidence != null && <span className="shp-tag">Jistota AI {formatPercent(m.confidence)}</span>}
              <span className="shp-tag shp-tag--info">{emailTypeLabel(m.emailType)}</span>
              {DIRECTION_LABELS[m.direction] && <span className="shp-tag">{DIRECTION_LABELS[m.direction]}</span>}
              <span className={`shp-tag ${m.reviewState === 'open' ? 'shp-tag--warn' : ''}`}>{REVIEW_STATES[m.reviewState] || m.reviewState}</span>
            </div>
            <div className="shp-wrap" dir="auto" style={{ fontWeight: 700, fontSize: 14 }}>{m.subject || '(bez předmětu)'}</div>
            <div className="shp-small shp-muted shp-wrap" dir="auto">
              {sender} · <time dateTime={m.emailDate}>{formatDateTime(m.emailDate)}</time> · schránka {m.mailbox}
            </div>
            {m.reviewReasons?.length > 0 && <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}><ReasonChips reasons={m.reviewReasons} /></div>}
            {m.snippet && <div className="shp-snippet shp-wrap" dir="auto">{m.snippet}</div>}
            <div><ExternalLinkButton kind="gmail" url={m.gmailUrl} unavailable="Odkaz na Gmail není dostupný">Otevřít v Gmailu</ExternalLinkButton></div>
          </article>
        );
      })}
    </div>
  );
};

export default SourceEmails;
